export default "__VITE_ASSET__DONFuSzr__"